import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { persistStore } from "redux-persist";
import authSlice from "../Store/authSlice";
import UserSlice from "../Store/userSlice";

const reducers = combineReducers({
    auth: authSlice,
    user: UserSlice
 });
// Persist configuration
const persistConfig = {
  key: "root",       // Root key for persist storage
  storage,           // Local storage as the storage option
};

// Persisted reducer using the persistConfig
const persistedReducer = persistReducer(persistConfig, reducers);
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({ serializableCheck: false }) // Ensures non-serializable checks are bypassed
});

// Expose store to window object to avoid circular dependencies
window.store = store;

export const persistor = persistStore(store);  // Initialize persistor to manage persistence